import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, ButtonVariant, ButtonSize, IconColor, IconName, IconSize, Text, usePopoverHandlers, } from '@as/cotopaxi';
import { Stack } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { SortControlPopover } from './SortControlPopover';
export const SortControl = props => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { orderItems, currentOrderItem, onOrderChange } = props;
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers();
    const onItemClick = (newOrder) => {
        handlePopoverClose();
        return onOrderChange(newOrder);
    };
    return (_jsxs(Stack, { wrap: "wrap", align: "center", children: [_jsxs(Text, { inline: true, children: [t('product:product.sort'), ": "] }), _jsx(Button, { iconRight: {
                    name: anchorEl ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN,
                    color: IconColor.ACTION,
                    size: IconSize.MEDIUM,
                }, onClick: handlePopoverOpen, variant: ButtonVariant.TRANSPARENT, text: _jsx(Text, { emphasized: true, inline: true, children: t(`product:${currentOrderItem.value}`) }), size: ButtonSize.SMALL }), _jsx(SortControlPopover, { orderItems: orderItems, currentOrderItem: currentOrderItem, anchorEl: anchorEl, onClose: handlePopoverClose, onOrderChange: onItemClick })] }));
};
